import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import {
  selectIsDrawerFilterTableOpen,
  selectIsFilterShown,
  selectNationalities,
  selectStartups,
} from 'redux/selectors/workspace';
import {
  selectPeopleFilters,
  selectPeopleRoles,
  selectPeopleSkills,
} from 'redux/selectors/people';
import { selectUserType } from 'redux/selectors/auth';
import { getNationalities, getStartups, setFilterShown } from 'redux/actions/workspace';
import { getPeopleRoles, getPeopleSkills, setPeopleFilters } from 'redux/actions/people';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
  isFilterTableOpen: selectIsDrawerFilterTableOpen(state),
  startups: selectStartups(state),
  nationalities: selectNationalities(state),
  roles: selectPeopleRoles(state),
  skills: selectPeopleSkills(state),
  activeFilters: selectPeopleFilters(state),
  isFilterShown: selectIsFilterShown(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getStartups,
    getNationalities,
    getPeopleRoles,
    getPeopleSkills,
    setPeopleFilters,
    setFilterShown,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
